
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'embedded-viral-link-ui',
  currentProjectVersion: 'static-1.6390',
  depVersions: {
  "embedded-viral-link-ui": "static-1.6390",
  "head-dlb": "static-1.4994",
  "hs-test-utils": "static-1.7994",
  "hubspot-dlb": "static-2.1845",
  "HubStyleTokens": "static-2.11447",
  "I18n": "static-7.1617",
  "jasmine-runner": "static-1.6445",
  "quartz": "static-1.6999",
  "quartz-core": "static-1.6218",
  "react-dlb": "static-1.78",
  "webpack-env": "static-1.54",
  "cssUtils": "static-1.786",
  "enviro": "static-4.446",
  "foundations-components": "static-1.7890",
  "hub-http": "static-1.6201",
  "hubspot-url-utils": "static-1.4115",
  "HubStyle": "static-2.11754",
  "icons": "static-2.644",
  "immer": "static-1.33",
  "laboratory-lib": "static-3.7137",
  "PortalIdParser": "static-2.397",
  "quartz-config": "static-1.777",
  "quartz-routing": "static-1.429",
  "quick-fetch": "static-1.3897",
  "react": "static-7.185",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16646",
  "react-select-plus": "static-1.104",
  "react-utils": "static-2.5325",
  "react-virtualized": "static-2.98",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "signup-constants": "static-1.18801",
  "signup-ui-lego-core": "static-1.20811",
  "styled-components": "static-2.89",
  "StyleGuideUI": "static-3.486",
  "ui-addon-react-router-dom": "static-1.9523",
  "ui-images": "static-2.1147",
  "UIComponents": "static-3.8393",
  "usage-tracker": "static-1.7323",
  "usage-tracker-core": "static-1.7173",
  "viral-links-lib": "static-1.7036",
  "hs-promise-rejection-tracking": "static-1.5566",
  "raven": "static-3.5907",
  "raven-hubspot": "static-1.6214",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9619",
  "bend-plugin-trellis-migration": "static-1.3385",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3276",
  "quartz-webpack": "static-1.3223",
  "bend-plugin-quartz-routing": "static-1.77",
  "HeadJS": "static-2.754",
  "framer-motion": "static-1.71",
  "hs-test-utils-bend-plugin": "static-1.3105",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "foundations-theming": "static-1.4397",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.82",
  "jasmine": "static-4.4306",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.830",
  "hubspotter-http": "static-1.4634",
  "mobile-manifest-mixins": "static-1.529",
  "module-federation": "static-1.22",
  "quartz-auth": "static-1.674",
  "quartz-head": "static-1.664",
  "quartz-i18n": "static-1.674",
  "quartz-test": "static-1.674",
  "quartz-tracking": "static-1.378",
  "ui-fonts": "static-1.709",
  "usage-tracker-container": "static-1.7313",
  "sassPrefix": "static-1.155",
  "bend-plugin-foundations-components": "static-1.4159",
  "floating-ui": "static-1.55",
  "foundations-assets": "static-1.4843",
  "foundations-theming-specialty": "static-1.2113",
  "hs-story-utils": "static-1.9406",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.15",
  "tanstack-table": "static-1.54",
  "trellis-assets": "static-1.1809",
  "hs-locale-management": "static-1.66",
  "superstore": "static-1.4742",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "csstype": "static-1.50",
  "web-vitals": "static-1.4",
  "rpc-client-utils": "static-1.4630",
  "emoji-regex": "static-1.7",
  "PatternValidationJS": "static-1.437",
  "signup-ui-url-generator": "static-2.8021",
  "bender-build-tools": "static-1.3171",
  "bend-plugin-foundations-theming": "static-1.2880",
  "foundations-theming-base": "static-1.3382",
  "stylex": "static-1.32",
  "hub-http-shared-msw-handlers": "static-1.9905",
  "hubspotter-http-shared-msw-handlers": "static-1.9903",
  "usage-tracker-session-replay": "static-1.5009",
  "bend-plugin-chirp-manifest": "static-1.40",
  "chirp-fetch": "static-1.1866",
  "ts-schema": "static-1.4062",
  "amplitude-session-replay-browser": "static-1.59"
},
  depPathPrefixes: {
  "embedded-viral-link-ui": "/embedded-viral-link-ui/static-1.6390",
  "head-dlb": "/head-dlb/static-1.4994",
  "hs-test-utils": "/hs-test-utils/static-1.7994",
  "hubspot-dlb": "/hubspot-dlb/static-2.1845",
  "HubStyleTokens": "/HubStyleTokens/static-2.11447",
  "I18n": "/I18n/static-7.1617",
  "jasmine-runner": "/jasmine-runner/static-1.6445",
  "quartz": "/quartz/static-1.6999",
  "quartz-core": "/quartz-core/static-1.6218",
  "react-dlb": "/react-dlb/static-1.78",
  "webpack-env": "/webpack-env/static-1.54",
  "cssUtils": "/cssUtils/static-1.786",
  "enviro": "/enviro/static-4.446",
  "foundations-components": "/foundations-components/static-1.7890",
  "hub-http": "/hub-http/static-1.6201",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4115",
  "HubStyle": "/HubStyle/static-2.11754",
  "icons": "/icons/static-2.644",
  "immer": "/immer/static-1.33",
  "laboratory-lib": "/laboratory-lib/static-3.7137",
  "PortalIdParser": "/PortalIdParser/static-2.397",
  "quartz-config": "/quartz-config/static-1.777",
  "quartz-routing": "/quartz-routing/static-1.429",
  "quick-fetch": "/quick-fetch/static-1.3897",
  "react": "/react/static-7.185",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16646",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-utils": "/react-utils/static-2.5325",
  "react-virtualized": "/react-virtualized/static-2.98",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "signup-constants": "/signup-constants/static-1.18801",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20811",
  "styled-components": "/styled-components/static-2.89",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9523",
  "ui-images": "/ui-images/static-2.1147",
  "UIComponents": "/UIComponents/static-3.8393",
  "usage-tracker": "/usage-tracker/static-1.7323",
  "usage-tracker-core": "/usage-tracker-core/static-1.7173",
  "viral-links-lib": "/viral-links-lib/static-1.7036",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5566",
  "raven": "/raven/static-3.5907",
  "raven-hubspot": "/raven-hubspot/static-1.6214",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9619",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3385",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3276",
  "quartz-webpack": "/quartz-webpack/static-1.3223",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.77",
  "HeadJS": "/HeadJS/static-2.754",
  "framer-motion": "/framer-motion/static-1.71",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3105",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "foundations-theming": "/foundations-theming/static-1.4397",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.82",
  "jasmine": "/jasmine/static-4.4306",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.830",
  "hubspotter-http": "/hubspotter-http/static-1.4634",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.529",
  "module-federation": "/module-federation/static-1.22",
  "quartz-auth": "/quartz-auth/static-1.674",
  "quartz-head": "/quartz-head/static-1.664",
  "quartz-i18n": "/quartz-i18n/static-1.674",
  "quartz-test": "/quartz-test/static-1.674",
  "quartz-tracking": "/quartz-tracking/static-1.378",
  "ui-fonts": "/ui-fonts/static-1.709",
  "usage-tracker-container": "/usage-tracker-container/static-1.7313",
  "sassPrefix": "/sassPrefix/static-1.155",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4159",
  "floating-ui": "/floating-ui/static-1.55",
  "foundations-assets": "/foundations-assets/static-1.4843",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2113",
  "hs-story-utils": "/hs-story-utils/static-1.9406",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.15",
  "tanstack-table": "/tanstack-table/static-1.54",
  "trellis-assets": "/trellis-assets/static-1.1809",
  "hs-locale-management": "/hs-locale-management/static-1.66",
  "superstore": "/superstore/static-1.4742",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.4",
  "rpc-client-utils": "/rpc-client-utils/static-1.4630",
  "emoji-regex": "/emoji-regex/static-1.7",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8021",
  "bender-build-tools": "/bender-build-tools/static-1.3171",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2880",
  "foundations-theming-base": "/foundations-theming-base/static-1.3382",
  "stylex": "/stylex/static-1.32",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9905",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9903",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5009",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.40",
  "chirp-fetch": "/chirp-fetch/static-1.1866",
  "ts-schema": "/ts-schema/static-1.4062",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59"
}
};
